const saveToLocalStorage = (key, data) => {
    try {
      const dataToStore = JSON.stringify(data);
      localStorage.setItem(key, dataToStore);
    } catch (error) {
      console.error('Error saving to local storage', error);
    }
};

export default saveToLocalStorage